import findAncestor from './findAncestor.js';

var toggleDropdown = function(event, currentElement){
  if( currentElement ){ 
    var hadDropdownPaneLink = findAncestor(event.target, 'dropdownpane-link');
    var allDropdownPaneLinks = currentElement.querySelectorAll('.dropdownpane-link');
    allDropdownPaneLinks.forEach(function(dropdownPaneLink) {
      if (dropdownPaneLink.nextElementSibling.classList.contains('is-open') && hadDropdownPaneLink != dropdownPaneLink) {
        dropdownPaneLink.nextElementSibling.classList.remove('is-open');
        dropdownPaneLink.classList.remove('active');
      }
    });
  }
}

export default toggleDropdown;